export default {
  // 查询航班列表
  async getSpFlightList(params) {
    // let actiontype = 'SpecialService_SpecialServiceDetrTNHandler2';
    let actiontype = "getSpecialServiceFlightInfo";
    return await this.fetch(actiontype, params);
  },
  //特殊旅客申请
  async applySpecialService(params) {
    // let actiontype = 'SpecialService_ApplySpecialServiceHandler'
    let actiontype = "applySpecialServiceNew";
    return await this.fetch(actiontype, params);
  },
  //取消特殊旅客申请
  async cancelSpecialService(params) {
    let actiontype = "SpecialService_CancelSpecialServiceHandler";
    return await this.fetch(actiontype, params);
  },
  //特殊旅客查询
  async getSpecialServiceInfo(params) {
    let actiontype = "SpecialService_GetSpecialServiceInfoHandler";
    return await this.fetch(actiontype, params);
  },
  // 通过申请单号获取航班信息
  async getSpFlightInfoByApplyNo(params) {
    let actiontype = "SpecialService_GetSpecialServiceDetailHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取验证码特殊旅客
  async getSpPhoneVerify(params) {
    let actiontype = "SpecialPassenger_GetPhoneVerifyCodeHandler";
    return await this.fetch(actiontype, params);
  },

  // 新阶段特殊旅客-获得订单信息
  async getSpecialOrderInfo(params) {
    let actiontype = "PassengerService_SpecialServiceCustomerQueryDetailNew";
    return await this.fetch(actiontype, params);
  },

  // 新阶段特殊旅客-提交证明/取消订单
  async submitSpecialOrder(params) {
    let actiontype = "PassengerService_SpecialServiceCustomerUploadOrCancelNew";
    return await this.fetch(actiontype, params);
  },
  // 特殊旅客H5：申请单详情（人体器官等）
  async getSpecialApplicationDetail(params = {}) {
    let actiontype = "psgService_h5_applicationDetail";
    return await this.fetch(actiontype, params);
  },
  // opo获取安全校验的姓名，智慧服务过来需要补全姓名
  async specialGetPassengerName(params) {
    let actiontype = "psgService_h5_getPassengerName";
    return await this.fetch(actiontype, params);
  },
  // 特殊旅客H5申请书（A类）详情
  async specialH5ApplicationDetail(params) {
    let actiontype = "specialH5ApplicationDetail";
    return await this.fetch(actiontype, params, true);
  },
  // 特殊旅客H5申请书（A类）提交签名
  async specialH5ApplicationSubmit(params) {
    let actiontype = "specialH5ApplicationSubmit";
    return await this.fetch(actiontype, params, true);
  },
  // opo校验安全校验的姓名，智慧服务过来需要补全姓名
  async specialValidPassenger(params) {
    let actiontype = "psgService_h5_validPassenger";
    return await this.fetch(actiontype, params);
  },
  // 特殊旅客H5：提交申请单
  async specialSubmitSignature(params) {
    let actiontype = "psgService_h5_submitSignature";
    return await this.fetch(actiontype, params);
  }
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/special.js